import {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {KTIcon} from '../../../../helpers'
import {useRbacPermissions} from '../../../../../app/modules/auth/core/permissions'

const SHOWN_ACTIONS = ['read', 'create', 'update']

type ResourcePermission = {
  resource: string
  read: boolean
  create: boolean
  update: boolean
  availableActions: string[]
}

const ModalViewRole = ({show, setShow, curr}) => {
  const [roleName, setRoleName] = useState(curr?.name)
  const [roleDescription, setRoleDescription] = useState(curr?.description)
  const [permissions, setPermissons] = useState<ResourcePermission[]>([])
  const {data: permissionCatalog = []} = useRbacPermissions()

  useEffect(() => {
    setRoleName(curr?.name)
    setRoleDescription(curr?.description)
    if (!permissionCatalog.length) return

    const granted = new Set(
      (curr?.permissions ?? []).map((p: any) => `${p.resource}:${p.action}`)
    )

    const map: Record<string, ResourcePermission> = {}
    permissionCatalog.forEach((p: any) => {
      if (!SHOWN_ACTIONS.includes(p.action)) return
      if (!map[p.resource]) {
        map[p.resource] = { resource: p.resource, read: false, create: false, update: false, availableActions: [] }
      }
      if (!map[p.resource].availableActions.includes(p.action)) {
        map[p.resource].availableActions.push(p.action)
      }
      if (granted.has(`${p.resource}:${p.action}`)) {
        map[p.resource][p.action] = true
      }
    })
    setPermissons(Object.values(map))
  }, [curr, permissionCatalog])

  return (
    <Modal
      className='modal-sticky modal-lg modal-sticky-lg modal-sticky-bottom-right'
      show={show}
      centered={true}
    >
      <div className='modal-header'>
        <h2>View role</h2>

        <div className='d-flex justify-content-end'>
          <button
            className='ms-auto btn btn-sm btn-icon btn-active-color-primary'
            onClick={() => setShow(false)}
          >
            <KTIcon iconName='cross' className='text-gray fs-1' />
          </button>
        </div>
      </div>

      <div className='modal-body py-lg-0 px-lg-0'>
        <div className='modal-body scroll-y mx-lg-5 my-7'>
          <form className='form'>
            <div className='d-flex flex-column scroll-y me-n7 pe-7'>
              <div className='fv-row mb-10'>
                <label className='fs-5 fw-bold form-label mb-2'>
                  <span className='required'>Role name</span>
                </label>
                <input
                  className='form-control form-control-solid'
                  placeholder='Enter a role name'
                  name='role_name'
                  value={roleName}
                  disabled
                />
              </div>
              <div className='fv-row mb-10'>
                <label className='fs-5 fw-bold form-label mb-2'>
                  <span className='required'>Role description</span>
                </label>
                <input
                  className='form-control form-control-solid'
                  placeholder='Enter a role description'
                  name='description'
                  value={roleDescription}
                  disabled
                />
              </div>
              <div className='fv-row'>
                <label className='fs-5 fw-bold form-label mb-2'>Role Permissions</label>
                <div className='table-responsive'>
                  <table className='table align-middle table-row-dashed fs-6 gy-5'>
                    <tbody className='text-gray-600 fw-semibold'>
                      <tr>
                        <td className='text-gray-800'>
                          Administrator Access
                          <i
                            className='fas fa-exclamation-circle ms-1 fs-7'
                            data-bs-toggle='tooltip'
                            title='Allows a full access to the system'
                          />
                        </td>
                        <td>
                          <label className='form-check form-check-custom form-check-solid me-9'>
                            <input
                              className='form-check-input'
                              type='checkbox'
                              defaultValue=''
                              id='kt_roles_select_all'
                              disabled
                            />
                            <span
                              className='form-check-label'
                              // htmlFor="kt_roles_select_all"
                            >
                              Select all
                            </span>
                          </label>
                        </td>
                      </tr>
                      {permissions?.map((permission) => (
                        <tr key={permission.resource}>
                          <td className='text-gray-800 text-capitalize'>{permission.resource.replace(/_/g, ' ')}</td>
                          <td>
                            <div className='d-flex'>
                              {(['read', 'create', 'update'] as const).map((action) =>
                                permission.availableActions.includes(action) ? (
                                  <label key={action} className='form-check form-check-sm form-check-custom form-check-solid me-5 me-lg-20'>
                                    <input
                                      className='form-check-input'
                                      type='checkbox'
                                      checked={permission[action]}
                                      readOnly
                                    />
                                    <span className='form-check-label text-capitalize'>{action}</span>
                                  </label>
                                ) : null
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className='text-center pt-15'>
              <button type='reset' className='btn btn-light me-3' onClick={() => setShow(false)}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}

export default ModalViewRole
